module.exports = __webpack_public_path__ + "static/media/sided_new.85558242.png";